import { render, staticRenderFns } from "./RegV3Admin.vue?vue&type=template&id=16322999"
import script from "./RegV3Admin.vue?vue&type=script&lang=js"
export * from "./RegV3Admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports